import { useCallback } from 'react';
import { FormInstance } from 'components';

export const useFilters = ({ form, resetFilters }: { form: FormInstance; resetFilters: () => void }) => {
  const clearFilters = useCallback(() => {
    form.resetFields();
    resetFilters();
  }, [form, resetFilters]);

  return {
    clearFilters,
  };
};
